import React, { Component } from 'react';
import { NavLink as RouterLink } from 'react-router-dom';
import ListItem from "@material-ui/core/es/ListItem";
class NavItem extends Component {

  constructor(props) {
    super(props);
  }

  handleToggle = () => {
    this.setState({open: !this.state.open})
  };

  render(){
    const { title,
      href,
      depth,
      icon: Icon,
      open: openProp,
      onMobileClose,
      info: Info} = this.props;
      if (depth > 0) {
        paddingLeft = 32 + 8 * depth;
      }
    return (
      <ListItem
        button
        disableGutters
        key={title}
        exact
        activeClassName={'menu-btn-active'}
        className="menu-btn"
        to={href}
        component={RouterLink}
        onClick={onMobileClose}
        >
          {Icon && (
            <Icon
              style={{display: 'flex',
              alignItems: 'center',
              marginRight: '10px'}}
              size="20"
            />
          )}
          <span style={{ marginRight: 'auto'}}>
            {title}
          </span>
          {Info && <Info />}
      </ListItem>
    );
  }
}

export default NavItem;



// WEBPACK FOOTER //
// ./src/containers/app/components/DashboardLayout/NavBar/NavItem.js